module.exports = __webpack_public_path__ + "static/media/bg_front_page_3.c1db4752.png";